import React from 'react';
import { Col, Form, FormInstance, Row } from 'antd';
import AssetsTable from 'pages/ProposalV3/PropDetail/AssetsTable';
import FormInput from 'components/FormInput';
import Value from 'components/Value';
import { AssetRequest } from 'services/proposal';
import { getAssetCatalogRvAmountList } from 'services/assetconfig';
import { sumBy } from 'lodash';
import { AssetResponse } from 'services/assets';
import _ from 'lodash';
export type CardsProps = {
  ctrid?: number;
  phase: 'PROD' | 'PROPOSAL';
  form?: FormInstance;
  reftechProp?: () => void;
  showActionButton?: boolean;
  filtersList: any;
};

const Cards = ({
  form,
  ctrid,
  phase,
  reftechProp,
  showActionButton = true,
  filtersList,
}: CardsProps) => {
  const handleMoveAsset = (asset: AssetResponse) => {
    const cteid = form?.getFieldValue('selectedElement');
    let assets = form?.getFieldValue('assets');
    let indexAsset = assets.findIndex(
      (item: any) => item.assetid === asset.assetid
    );

    let elements = form?.getFieldValue('elements') || {};
    let finElements = form?.getFieldValue(['elements', 'FIN']) || {};
    let finOldElement = finElements.find((e: any) => e.cteid === cteid);

    let indexElement = finElements.findIndex(
      (item: any) => item.cteid === cteid
    );

    finElements[indexElement].cteinvestamount =
      finOldElement.cteinvestamount - asset.assetnetamount;
    finElements[indexElement].ctefinancedamount =
      finOldElement.ctefinancedamount - asset?.assetnetamount;

    let finNewElement = finOldElement;
    const cteidNew = Math.round(_.random(10000) * 10000000);

    finNewElement.cteid = cteidNew;
    finNewElement.ctefinancedamount = asset?.assetnetamount;
    finNewElement.cteinvestamount = asset?.assetnetamount;
    finNewElement.ctepartamount = 0;
    finNewElement.cteupfrontamount = 0;
    finNewElement.conElemAttributes = [];

    assets[indexAsset].cteid = cteidNew;

    // add :
    finElements.push(finNewElement);

    elements = { ...elements, FIN: finElements };

    form?.setFieldsValue({
      elements: elements,
      assets: assets,
      ctfclevel: 'MULTI',
      selectedElement: cteidNew,
    });

    /*if (isNil(finNewElement.pricing)) {
      handleOfferChange(form.getFieldValue('offerid'));
    } else {
      handlePricingChange(
        finNewElement.pricing,
        finNewElement.ctepartmethod,
        finNewElement.ctepartamount
      );
    }*/
  };

  const handleDeleteAsset = (assetD: any) => {
    const newList = form
      ?.getFieldValue('assets')
      .filter((asset: any) => asset.assetid !== assetD.assetid);

    const tpidsupplier = form
      ?.getFieldValue('assets')
      .find((asset: any) => asset.assetid === assetD.assetid).tpidsupplier;

    if (
      newList.find((asset: any) => asset.tpidsupplier === tpidsupplier) ===
      undefined
    ) {
      const newTP = form
        ?.getFieldValue('thirdparties')
        .filter(
          (tp: any) =>
            tp.tpid.tpid !== tpidsupplier || tp.tprolecode !== 'SUPPLIER'
        );
      const newSUP = newTP.find((tp: any) => tp.tprolecode === 'SUPPLIER');
      form?.setFieldsValue({
        thirdparties: newTP,
        supplier: newSUP === undefined ? null : newSUP,
      });
    }

    form?.setFieldsValue({
      assets: newList,
      ctfinancedamount:
        form.getFieldValue('ctfinancedamount') - assetD.assetfinamount,
      offerid: null,
      authid: null,
      authdetailid: null,
      authdetailamount: null,
      authdetailavailableamount: null,
      authbookedamount: null,
      authdetailusedamount: null,
      pricing: null,
      elements: [],
    });
  };

  const handleSaveAsset = async (asset: any) => {
    const listrv = await getAssetCatalogRvAmountList({
      prcode: form?.getFieldValue('prcode') ?? '',
      catalogid: asset.catalogid ?? '',
      assetamount: asset.assetnetamount,
      filters: filtersList,
    }).then((res: any) => res.list);

    asset.listrv = listrv;
    asset.cteid = form?.getFieldValue('selectedElement');

    form?.setFieldsValue({
      assets: form
        .getFieldValue('assets')
        .map((existingAsset: AssetRequest) => {
          return existingAsset.assetid === asset.assetid
            ? asset
            : existingAsset;
        }),
    });

    form?.setFieldsValue({
      ctfinancedamount: sumBy(form.getFieldValue('assets'), 'assetnetamount'),
      offerid: null,
      authdetailid: null,
      authdetailamount: null,
      authdetailavailableamount: null,
      authbookedamount: null,
      authdetailusedamount: null,
      pricing: null,
      elements: [],
    });
  };

  return (
    <Form form={form}>
      {ctrid && (
        <Row gutter={16} style={{ marginTop: 20, paddingLeft: 20 }}>
          <Col span={6}>
            <FormInput name="statusasset">
              <Value />
            </FormInput>
          </Col>

          <Col>
            <FormInput name="ctvaliditydate">
              <Value />
            </FormInput>
          </Col>
        </Row>
      )}
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const assets = getFieldValue('assets') ?? [];
          return (
            <AssetsTable
              ctrid={ctrid}
              currcode={getFieldValue('currcode')}
              assets={[...assets]}
              onSaveAsset={handleSaveAsset}
              onMoveToNewelement={handleMoveAsset}
              onDelete={handleDeleteAsset}
              reftechProp={reftechProp}
              ctfclevel={getFieldValue('ctfclevel')}
              phase="PROPOSAL"
              flagreal={Boolean(getFieldValue('flagrealestate'))}
              fromproposal
              proposalData={{
                pricing: getFieldValue('pricing'),
                prcode: getFieldValue('prcode'),
                duration: getFieldValue('cteduration'),
                offerid: getFieldValue('offerid'),
              }}
              mfuse={
                getFieldValue('ctidautorization') === null ||
                getFieldValue('ctidautorization') === undefined
                  ? false
                  : true
              }
            />
          );
        }}
      </Form.Item>
    </Form>
  );
};
export default Cards;
